import React from 'react';
import ShadowBox from '../ShadowBox/ShadowBox';
import s from './AppCard.module.css';

const AppCard = ({ item }) => (
  <div className={s.appCard}>
    <ShadowBox>
      <a href={item.link} target="_blank" rel="noopener noreferrer">
        <div className={s.appCardInner}>
          <img 
            src={`${window.location.origin}/img/${item.img}.png`} 
            height="35px" 
            width="35px" 
            alt="Logo" 
          />
          <p style={{ fontSize: '13px' }}>{item.name}</p>
        </div>
      </a>
    </ShadowBox>
  </div>
);

export default AppCard;
